// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body,\n#root {\n  margin: 0;\n  padding: 0;\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  font-family: 'Inter', sans-serif;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n", ""]);
// Exports
module.exports = exports;
